import React from 'react';
import  ConditioningGirls2024  from 'views/ConditioningGirls2024';
const BlogNewsroomPage = () => {
return <ConditioningGirls2024/>
};
export default BlogNewsroomPage;